import React, { useEffect, useState, useRef } from "react";
import { MetaTags } from "../../Components/Layout/MetaTags.jsx";
import { Header } from "../../Components/Layout/Header.jsx";
import { ObavijestiCasino } from "../../Components/Layout/ObavijestiCasino.jsx";
import { GameDetails } from "../../Components/Game/GameDetails.jsx";
import { Redirect } from "react-router-dom";


export default function SuperAvanturaPage(props) {
    const [height, setHeight] = useState(null);
    const [modal, setModal] = useState("close");
    const [dialogData, setDialogData] = useState(null);
    const [redirectToGameUrl, setRedirectToGameUrl] = useState(false);
    const iframeRef = useRef(null);
    const superAvanturaRef = useRef(null);
    const adventureType = new URL(window.location.href).searchParams.get("sifraavanture")?.split('?')[0];

    useEffect(() => {
        if (props.route.location.pathname.indexOf("/game/") === -1) {
            setRedirectToGameUrl(false);
        }
    }, [props.route.location]);

    // Send
    useEffect(() => {
        window.addEventListener("scroll", sendScrollTopOffset);
        return () => {
            window.removeEventListener("scroll", sendScrollTopOffset);
        };
    }, [window.scrollY]);

    useEffect(() => {
        setTimeout(() => {
            window.scrollTo(0, 0);
            sendRenderMobile();
        }, 750)

        // Receive
        window.addEventListener("message", receiveMessages);
        return () => window.removeEventListener("message", receiveMessages);
    }, []);

    const sendRenderMobile = () => {
        if (iframeRef.current?.contentWindow) {
            const childWindow = iframeRef.current.contentWindow;

            // Send render context message to the child iframe
            childWindow.postMessage({
                type: "renderContext",
                renderMobile: true,
            }, "*");
        } else {
            console.error("iframe is not ready");
        }
    };

    const sendScrollTopOffset = () => {
        if (iframeRef.current?.contentWindow) {
            const childWindow = iframeRef.current.contentWindow;

            childWindow.postMessage({
                type: "scrollTopOffset",
                scrollTopOffset: window.scrollY
            }, "*");
        } else {
            console.error("iframe is not ready");
        }
    };

    let gameUrl = dialogData && `/promotions/super-avantura/game/${dialogData.brandName}/${casino.utils.normalizeString(dialogData.game.n)}?sifraavanture=${adventureType}`;

    const receiveMessages = (message) => {
        if (message.data.type == `${adventureType}-height`) {
            setHeight(message.data.scrollHeight + "px");
        }

        if (message.data.type == "scrollToZero") {
            setTimeout(() => {
                window.scrollTo(0, message.data.top);
            }, 750)
        }

        if (message.data.type === "modalOpen") {
            const modalStatus = message.data.isModalOpen;
            const html = document.getElementsByTagName("html")[0];
            const header = document.getElementById("header");
            setModal(modalStatus ? "open" : "close");

            if (html && header) {
                html.style.overflow = modalStatus ? "hidden" : "auto";
                header.style.zIndex = modalStatus && 1;
                superAvanturaRef.current.style.position = modalStatus ? "relative" : "initial";
            }
        }

        if (message.data.type == "dialog") {
            let gameCode = message.data.params.sifra;
            if (casino.config.fromNativeApp) {
                //hotfix, ovo treba presloziti bolje jer za druge promocije opet nebu delalo
                gameUrl = `supersport://casino/games/${gameCode}`
                window.location.href = gameUrl
            } else {
                let game = casino.casinoConstants.games.filter((game) => game.s == gameCode)[0];
                let brandName = casino.casinoConstants.brands[game.bID].nameNormalizirano;
                setDialogData({ game, brandName });
            }
            setRedirectToGameUrl(true);
        }

        if (message.data.type == "urlParameter") {
            const baseUrl = casino.utils.getBaseUrl();
            const targetUrl = baseUrl + message.data.urlParam;
            window.location.href = targetUrl;
        }
    };

    return (
        <>
            {redirectToGameUrl && !casino.config.fromNativeApp && <Redirect to={gameUrl} />}
            <MetaTags
                title="Promocije - SuperSport CASINO"
                description="Super Avantura u SuperSport CASINU!"
            />
            <Header {...props} />
            <main id="SuperAvantura" ref={superAvanturaRef} className="super-avantura-container">
                <iframe
                    className={modal}
                    ref={iframeRef}
                    title="Super Avantura"
                    src={`${casino.config.casinoModulesUrl}super-avantura?sifraavanture=${adventureType}`}
                    scrolling="no"
                    height={height}
                />
                <div className={"module-modal " + modal} />
            </main>
            <GameDetails
                {...props}
                igre={casino.casinoConstants.games}
                routePrefix={`/promotions/super-avantura?sifraavanture=${adventureType}`}
                urlParam={adventureType}
            />
            <ObavijestiCasino {...props} />
        </>
    )
};

